module.exports = function(h, row) {
    let typeOptions = [],
        varianceSelector,
        varianceList = [];
    const countedQty = row.counted_quantity || 0;
    const hasCountedQty =
        row.counted_quantity !== null && row.counted_quantity !== '';

    const difference = Math.abs(countedQty - row.expected_quantity);

    const totalVarianceQtyAdded = row.variance.reduce(
        (a, c) => a + parseFloat(Math.abs(c.quantity)),
        0,
    );

    const maxVariance = (
        parseFloat(difference) - totalVarianceQtyAdded
    ).toFixed(2);

    const addReason = row => {
        const qytElem = document.getElementById(`qty_${row.stock_id}`);
        const varianceReason = document.getElementById(
            `variance_${row.stock_id}`,
        ).value;
        const closeElem = document.getElementById(
            `closeTooltip${row.stock_id}`,
        );

        if (!this.validateParsleyForm(`variance_form_${row.stock_id}`)) return;

        const variance = {
            stock_id: row.stock_id,
            quantity: qytElem.value,
            type: varianceReason,
        };

        this.saveStockVariance(variance);
        qytElem.value = '';
        // trigger close directive
        closeElem.click();
    };

    this.varianceTypes.forEach(type => {
        const typeAdded = !!row.variance.find(v => v.type == type.id);

        if (!typeAdded) {
            typeOptions.push(<option value={type.id}>{type.name}</option>);
        }
    });

    row.variance.forEach(v => {
        const varianceType = this.varianceTypes.find(r => r.id == v.type);
        varianceList.push(
            <li>
                {`${Math.abs(v.quantity)} ${varianceType.name}`}
                {!this.hasFinalized ? (
                    <i
                        onClick={() =>
                            this.removeStockVariance({
                                stock_id: row.stock_id,
                                variance: v,
                            })
                        }
                        class="m-l-sm material-icons text-muted pointer hidden-print"
                    >
                        clear
                    </i>
                ) : (
                    ''
                )}
            </li>,
        );
    });

    varianceSelector = (
        <select required id={`variance_${row.stock_id}`} class="md-input">
            {typeOptions}
        </select>
    );

    return (
        <div>
            <ul class="p-l-md m-b-xs">{varianceList}</ul>

            {!this.hasFinalized ? (
                <v-popover offset="16">
                    <span
                        v-show={maxVariance > 0 && hasCountedQty}
                        class="text-info pointer hidden-print clear m-l-sm text-link"
                    >
                        Add Reason
                    </span>

                    <span
                        class="clear text-danger"
                        v-show={this.errors.has(
                            'variance',
                            `variance_${row.stock_id}`,
                        )}
                    >
                        {this.errors.first(
                            'variance',
                            `variance_${row.stock_id}`,
                        )}
                    </span>

                    <template slot="popover">
                        <form
                            id={`variance_form_${row.stock_id}`}
                            onSubmit={e => {
                                e.preventDefault();
                                addReason(row);
                            }}
                        >
                            <div class="md-form-group">
                                <input
                                    required
                                    id={`qty_${row.stock_id}`}
                                    class="md-input"
                                    max={maxVariance}
                                    autocomplete="off"
                                    data-parsley-greater-than="0"
                                    data-parsley-type="number"
                                    placeholder="Qty"
                                />
                                <label>Variance Qty </label>
                                <span class="md-input-msg right">
                                    Max {maxVariance}
                                </span>
                            </div>

                            <div class="md-form-group">
                                {varianceSelector}
                                <label>Variance Reason</label>
                            </div>

                            <div class="clear">
                                <a
                                    class="btn btn-xs primary m-r-xs"
                                    onClick={() => {
                                        addReason(row);
                                    }}
                                >
                                    Add
                                </a>
                                <a
                                    v-close-popover
                                    id={`closeTooltip${row.stock_id}`}
                                    class="btn btn-xs white"
                                >
                                    Close
                                </a>
                            </div>
                        </form>
                    </template>
                </v-popover>
            ) : (
                ''
            )}
        </div>
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/stock_check/counted-stock-columns/variance-reasons.jsx